import { Box, Typography, Button, Link } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import img from "../../assets/ecommerce/crm.png";
import ecomm from "../../assets/ecommerce/storefront.png";
import productDescription from "../../assets/ecommerce/productDescription.png";
const Storefront = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      m="30px auto"
      p="30px"
      maxWidth="800px"
      border="2px solid #E5E8E8"
      borderRadius="12px"
      boxShadow="0px 3px 10px rgba(0, 0, 0, 0.1)"
      backgroundColor={colors.primary[900]}
    >
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        sx={{ color: "colors.primary[200]", mb: 3, fontWeight: "bold" }}
      >
        Back
      </Button>
      {/* Project Title */}
      <Typography
        variant="h3"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={2}
      >
        <Link
          href="https://ecomm-store-rosy.vercel.app/"
          target="_blank"
          underline="none"
          color="inherit"
          sx={{
            textDecoration: "none",
            px: 1,
            borderRadius: 1,
            transition: "background-color 0.3s",
            "&:hover": {
              backgroundColor: "grey.300",
              cursor: "pointer",
            },
          }}
        >
          Storefront
        </Link>
      </Typography>
      {/* Project Description */}
      <Typography variant="h5" color="#5D6D7E" mb={3}>
        An ecommerce store optimized for SEO and user experience
        {/* A super app for small business owners to sell online and manage their
        small businesses. I'm developing an online brand and online sales by
        designing a search optimized web application implementing the industry's
        best practices in UI/UX design. At TDC Doors, I have built some features
        including a pre sales onboarding questionaire, "Track My Order", as well
        as a customer support chatbot. Over the summer I was a software
        engineering fellow at Headstarter AI where I built full stack
        applications with AI powered features. A project I am currently working
        on is Storefront, a way to enhance small businesses. It is like google
        maps for customers to discover small businesses as well as a series of
        workflow tools for business owners to help manage their businesses. */}
      </Typography>
      <Box p={1}>
        <Typography
          variant="h5"
          fontWeight="bold"
          color={colors.primary[200]}
          mb={1}
        >
          Demo:
        </Typography>
        <iframe
          src="https://www.youtube.com/embed/5FF5NFD6QuA?autoplay=0&mute=1&loop=1"
          title="video"
          allow="autoplay"
          frameborder="0"
          style={{
            width: "90%",
            aspectRatio: "16 / 9",
            height: "auto",
          }}
        ></iframe>
      </Box>
      {/* modern landing page */}
      <Box
        sx={{
          mt: 1,

          overflow: "hidden",
          transition: "all 0.3s cubic-bezier(0.3, 0, 0.2, 1)",
        }}
        data-visible={true}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          color={colors.primary[200]}
          mb={1}
        >
          Call to action
        </Typography>
        <img src={ecomm} alt="" width="100%" />
      </Box>
      <Box
        sx={{
          mt: 1,

          overflow: "hidden",
          transition: "all 0.3s cubic-bezier(0.3, 0, 0.2, 1)",
        }}
        data-visible={true}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          color={colors.primary[200]}
          mb={1}
        >
          Detailed product description
        </Typography>
        <img src={productDescription} alt="" width="100%" />
      </Box>
      <Box
        sx={{
          mt: 1,

          overflow: "hidden",
          transition: "all 0.3s cubic-bezier(0.3, 0, 0.2, 1)",
        }}
        data-visible={true}
      >
        <Typography
          variant="h5"
          fontWeight="bold"
          color={colors.primary[200]}
          mb={1}
        >
          CRM for managing customer conversations
        </Typography>
        <img src={img} alt="" width="100%" />
      </Box>
      {/* detailed product description */}
      {/* crm */}
      {/* Problem */}
      {/* <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Problem:
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: colors.primary[200], mb: 3 }}>
       Designing an ecommerce store that is easy to browse products, view product details and checkout.
      </Box> */}
      {/* Technical Challenges */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        my={1}
      >
        Technical Challenges:
      </Typography>
      <Box component="ul" sx={{ pl: 3, color: "#5D6D7E", mb: 3 }}>
        <li>
          Designing modular UI components, that are aesthetic, elegant and
          intuitive
        </li>
        <li>
          Implement client side caching and optimize queries for UI
          responsiveness
        </li>
      </Box>
      {/* Technologies used */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technologies used:
      </Typography>
      <Box
        display={"flex"}
        flexWrap="wrap"
        maxWidth="800px"
        sx={{ pl: 3, color: colors.primary[200], mb: 3 }}
      >
        {[
          "FastAPI",
          "Next.js",
          "React",
          "Shadcn",
          "Zod",
          "Multer",
          "Apollo Client",
          "GraphQL",
          "Lambda",
          "DynamoDB",
          "S3",
        ].map((tech) => (
          <Box
            key={tech}
            component=""
            sx={{
              px: 1.5,
              py: 0.5,
              m: 0.5,
              border: `1px solid ${colors.primary[200]}`,
              borderRadius: "8px",
              color: colors.primary[200],
              fontSize: "0.875rem",
              backgroundColor: "rgba(255, 255, 255, 0.05)", // Subtle background
              "&:hover": {
                backgroundColor: colors.primary[200],
                color: "#000", // Contrast color on hover
                cursor: "default",
              },
            }}
          >
            {tech}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Storefront;
